import { render } from "./SectionButton.vue?vue&type=template&id=8612ac16"
import script from "./SectionButton.vue?vue&type=script&lang=js"
export * from "./SectionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__